import { render, staticRenderFns } from "./laptopView.vue?vue&type=template&id=1fdec0e0&scoped=true"
import script from "./laptopView.vue?vue&type=script&lang=js"
export * from "./laptopView.vue?vue&type=script&lang=js"
import style0 from "./laptopView.vue?vue&type=style&index=0&id=1fdec0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdec0e0",
  null
  
)

export default component.exports